const FooterMenuData = [
  {
    title: "בית המדרש",
    url: "/BeitHamidrash",
  },
  {
    title: 'שבושי"ם',
    url: "/Shvushim",
  },
  {
    title: "צרו קשר",
    url: "/Contact",
  },
  {
    title: "בוגרים",
    url: "Bogrim",
  },
  {
    title: "אודות",
    url: "/About",
  },
  {
    title: "הוצאה לאור",
    url: "/Publishing",
  },
  {
    title: "תרומות",
    url: "/Terumot",
  },
  {
    title: "עמוד הבית",
    url: "/",
  },
];

export default FooterMenuData;
